import { DocumentsTableColumnModel } from '../../../shared/components';
import { TableAlignEnum } from '../../../shared/components';

export function getConfigColumns(): DocumentsTableColumnModel[] {
  return [
    {
      name: '#',
      prop: 'acc 1',
      width: '40px'
    },
    {
      name: 'COLUMN.PRODUCT_ID',
      prop: 'productRunpleId',
      sortable: true,
      width: '152px',
      customizable: true
    },
    {
      name: 'COLUMN.PRODUCT_NAME',
      prop: 'productName',
      sortable: true,
      width: '1fr',
      minWidth: '160px'
    },
    {
      name: 'COLUMN.RETURN',
      prop: 'returned',
      cell: 'positions',
      sortable: true,
      alignment: TableAlignEnum.RIGHT,
      customizable: true,
      width: '120px'
    },
    {
      name: 'COLUMN.ON_STOCK',
      prop: 'onStock',
      cell: 'positions',
      sortable: true,
      alignment: TableAlignEnum.RIGHT,
      customizable: true,
      width: '120px'
    },
    {
      name: 'COLUMN.SOLD',
      prop: 'sold',
      cell: 'positions',
      sortable: true,
      alignment: TableAlignEnum.RIGHT,
      customizable: true,
      width: '120px'
    },
    {
      name: 'COLUMN.AVAILABLE',
      prop: 'available',
      cell: 'positionsHighlight',
      sortable: true,
      alignment: TableAlignEnum.RIGHT,
      customizable: true,
      width: '120px'
    },
    {
      name: 'COLUMN.CATEGORY',
      prop: 'categoryPath',
      sortable: true,
      customizable: true,
      width: '1fr',
      minWidth: '140px'
    },
    {
      name: null,
      prop: null,
      cell: 'expand',
      width: '64px'
    }
  ];
}
